import {LoadingController} from '@ionic/angular';
import {inject, Injectable} from '@angular/core';
import {SyncStatusItem} from '../../interfaces/core/sync-status-item';
import {TableName} from '../../enums/core/table-name';
import {Router} from '@angular/router';
import {SyncException} from '../../exceptions/sync.exception';
import {CdRaisTable} from '../care/cd-rais.table';
import {ConflictHandlerInstance} from '../../interfaces/core/conflict-handler-instance';
import {CdRai} from '../../interfaces/care/cd-rai/cd-rai';
import {CdMdsAnswersTable} from '../care/cd-mds-answers.table';
import {RaisService} from '../../services/care-plan/rais.service';
import {lastValueFrom} from 'rxjs';
import {environment} from '../../../environments/environment';
import {TimeoutHelper} from '../../helpers/timeout-helper';

@Injectable({
  providedIn: 'root'
})
export class CdRaiConflictHandler implements ConflictHandlerInstance {

  private _loadingController: LoadingController;
  private _router: Router;
  private _cdRaisTable: CdRaisTable;
  private _cdMdsAnswersTable: CdMdsAnswersTable;
  private _raisService: RaisService;

  /**
   *
   */
  constructor() {
    this._loadingController = inject(LoadingController);
    this._router = inject(Router);
    this._cdRaisTable = inject(CdRaisTable);
    this._cdMdsAnswersTable = inject(CdMdsAnswersTable);
    this._raisService = inject(RaisService);
  }

  /**
   *
   * @param syncStatusItem
   * @param syncException
   */
  public async handleConflict(syncStatusItem: SyncStatusItem, syncException: SyncException): Promise<void> {
    if(syncException.code !== 409) {
      return;
    }

    if(syncStatusItem.tableName === TableName.CdRais) {
      await this.handleCdRaiConflict(syncStatusItem);
    }
    else if(syncStatusItem.tableName === TableName.CdMdsAnswers) {
      await this.handleCdMdsAnswersConflict(syncStatusItem);
    }
  }

  /**
   *
   * @param syncStatusItem
   * @private
   */
  private async handleCdRaiConflict(syncStatusItem: SyncStatusItem): Promise<void> {
    // TODO: This conflict should be solved by the server
  }

  /**
   *
   * @param syncStatusItem
   * @private
   */
  private async handleCdMdsAnswersConflict(syncStatusItem: SyncStatusItem): Promise<void> {
    const loader = await this._loadingController.create({
      message: 'Konflikt erkannt...'
    });

    await loader.present();
    const cdMdsAnswer = await this._cdMdsAnswersTable.get(syncStatusItem.primaryKey);
    const cdRai = await this._cdRaisTable.get(cdMdsAnswer.cdRaiUuid);
    await this._cdRaisTable.remove(cdRai.uuid, true);

    try {
      const _cdRai = await lastValueFrom(this._raisService.loadLatestCdRai([cdRai.customerId]));
      await this._raisService.addCdRaisToTable(_cdRai);
    }
    catch(error) {
      if(!environment.production) {
        console.log(error);
      }
    }

    await loader.dismiss();
    await TimeoutHelper.sleep(100);

    if(await this.checkActiveRoute(cdRai)) {
      await this._router.navigate(['tabs', 'customer']);
    }
  }

  /**
   *
   * @param cdRai
   * @private
   */
  private async checkActiveRoute(cdRai: CdRai): Promise<boolean> {
    const cdRaiRoute = this._router.createUrlTree(['tabs', 'rai', cdRai.customerId.toString()]);
    const cdRaiEditRoute = this._router.createUrlTree(
      ['tabs', 'rai', cdRai.customerId.toString(), 'edit', cdRai.uuid]
    );
    // TODO: Deprecated isActive method
    return this._router.isActive(cdRaiRoute, true) || this._router.isActive(cdRaiEditRoute, true);
  }

}
